import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["start", "end", "output"]

  connect() {
    this.update()
  }

  update() {
    const start = this.parseDate(this.startTarget?.value)
    const end = this.parseDate(this.endTarget?.value)

    if (!start || !end || !this.outputTarget) {
      if (this.outputTarget) {
        this.outputTarget.textContent = "Select start and end dates to preview the range."
      }
      return
    }

    const startTime = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0)
    const endTime = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59)

    const formattedStart = this.formatDate(startTime)
    const formattedEnd = this.formatDate(endTime)

    this.outputTarget.innerHTML = `
      Data range: <span class="font-semibold">${formattedStart}</span>
      to <span class="font-semibold">${formattedEnd}</span> (local time)
    `
  }

  parseDate(value) {
    if (!value) return null
    const [year, month, day] = value.split("-").map(Number)
    if (!year || !month || !day) return null
    const parsed = new Date(year, month - 1, day)
    return Number.isNaN(parsed.getTime()) ? null : parsed
  }

  formatDate(date) {
    const pad = (num) => num.toString().padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  }
}
